//#region IMPORT
import React, { useEffect, useState, useRef } from 'react';
import M_FinalSign_BASIC from './M_FinalSign_BASIC';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { useSave1 } from './M_FinalSign_BASIC_Query';
import { useSave } from '../../../../Hooks/useSave';
import useFileUpload from '../../../../Hooks/useFileUpload';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
import { useTbmSessionSave } from '../hook/useSaveTbmSession';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
import { TbmActions } from '../../../../Reducer/TbmReducer';
//#endregion

function M_FinalSign_BASICF(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();
  const { sessionData, participantData, stepData } = useSelector((state) => state.tbm);
  const userInfo = useSelector((state) => state?.BaseInfo?.userInfo);
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  const [signInputs, setSignInputs] = useState({ mapUrl: '', mapFiles: {} });

  const signatureCanvas = useRef(null);
  const finalPathRef = useRef(''); // 서명 이미지 경로
  //#endregion

  //#region 커스텀훅
  const signUpload = useFileUpload({
    oldFilePathField: 'signImagePath',
    newFileNameField: 'saveName',
    getTargetPath: () => `TBM/${sessionData.sessionCd}/Sign`,
  });
  // 스택형 뒤로가기로 변경: TBM 종료 전 이탈 시 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTbmEnd' })),
  });
  const { SaveTbmSession } = useTbmSessionSave();
  //#endregion

  //#region 이벤트
  const Init = async () => {
    try {
      participantData.hostYn === 'Y' && SaveTbmSession([
        {
          ...sessionData,
          curStepOrder: stepData.find((f) => f.stepCode === props.stepCode)?.stepOrder,
          curStepCode: stepData.find((f) => f.stepCode === props.stepCode)?.stepCode,
          curPosition: stepData.find((f) => f.stepCode === props.stepCode)?.lastPosition,
        },
      ]);
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({
        open: true,
        message: e.message,
        type: 'error',
      }));
    }
  }
  useEffect(() => {
    Init();
    return () => {
      dispatch(BottomSheetActions.CloseBottomSheet());
    };
  }, [dispatch]);
  //#endregion

  //#region 쿼리
  const { runAsync: Save1Async } = useSave1();

  const { run: Save1 } = useSave({
    menuId: 'M_FinalSign_BASIC',
    fileSave: async () => {
      finalPathRef.current = await signUpload.SaveLogicFile();

      return { signImagePath: finalPathRef.current };
    },
    requestSave: (rows) => Save1Async(rows),
    onSuccess: (rows) => {
      Complete();
      signUpload.clearFiles();
    },
  });

  const SaveLogic1 = async () => {
    try {
      const exit = dayjs();
      const exitDt = exit.format('YYYY-MM-DD HH:mm:ss');
      const entranceMs = dayjs(String(participantData.entranceDt).replace(' ', 'T')).valueOf();
      const stayTime = Math.max(0, Math.floor((exit.valueOf() - entranceMs) / 1000));

      await Save1([{
        ...participantData,
        sessionCd: sessionData.sessionCd,
        completeYn: 'Y',
        signDate: dayjs().format('YYYY-MM-DD'),
        exitDt,
        stayTime,
      }]);

      if (participantData.hostYn === 'Y') {
        await SaveTbmSession([
          {
            ...sessionData,
            curStepOrder: stepData.find((f) => f.stepCode === props.stepCode)?.stepOrder,
            curStepCode: stepData.find((f) => f.stepCode === props.stepCode)?.stepCode,
            curPosition: stepData.find((f) => f.stepCode === props.stepCode)?.lastPosition,
            signPath: finalPathRef.current,
            signDate: dayjs().format('YYYY-MM-DD'),
          },
        ]);
      }
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({
        open: true,
        message: e.message,
        type: 'error',
      }));
    }
  };
  //#endregion

  //#region 나머지 함수
  const Complete = () => {
    dispatch(CommonActions.setActiveStep(0));
    dispatch(TbmActions.resetTbm());
    if (userInfo?.authCd === 'EMPLOYEE') {
      navigate('/M_PPE', { state: { tbmCd: props.tbmCdRef?.current } });
    } else {
      navigate('/Home');
    }
  };
  //#endregion

  return (
    <M_FinalSign_BASIC
      signatureCanvas={signatureCanvas}
      signInputs={signInputs}
      setSignInputs={setSignInputs}
      signUpload={signUpload}
      TbmEnd={props.TbmEnd}
      SaveLogic1={SaveLogic1}
    />
  );
}

export default M_FinalSign_BASICF;
